import Image from 'next/image';

import {Text} from '#component/base';
import {useViewportSize} from '#hook';

import BuyIndividualTestKit from './BuyIndividualTestKit/BuyIndividualTestKit';

import {AdditionalProductsRowProps} from './AdditionalProductsRow.types';

import * as css from './AdditonalProductsRow.css';

export const AdditionalProductsRow = ({
  image,
  isDiscounted,
  title,
  value,
  valueWithDiscount,
  variantId,
}: AdditionalProductsRowProps) => {
  const {isDesktop} = useViewportSize();
  const imageSize = isDesktop ? 80 : 60;
  const textColor = 'doveGray';

  return (
    <div className={css.ProductRowContainer}>
      <div className={css.ImageWrapper}>
        <Image width={imageSize} height={imageSize} src={image} alt={title} />
      </div>
      <div className={css.ContentContainer}>
        <div className={css.TitleWrapper}>
          <div>
            <Text variant="heading4" color="burgundy" className={css.TextTitleStyles}>
              {title}
            </Text>
          </div>
          <div>
            <Text
              color={textColor}
              className={`${isDiscounted ? css.LineThrough : ''} ${css.TextValueStyles}`}>
              ${value}
            </Text>
            {isDiscounted && (
              <Text className={css.TextValueStyles} color="eggplant">
                {' '}
                ${valueWithDiscount}
              </Text>
            )}
          </div>
        </div>
        <div className={css.ButtonValueStyles}>
          <BuyIndividualTestKit variantId={variantId} />
        </div>
      </div>
    </div>
  );
};
